var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33341 4.99967H5.83341C5.39139 4.99967 4.96746 5.17527 4.6549 5.48783C4.34234 5.80039 4.16675 6.22431 4.16675 6.66634V14.1663C4.16675 14.6084 4.34234 15.0323 4.6549 15.3449C4.96746 15.6574 5.39139 15.833 5.83341 15.833H13.3334C13.7754 15.833 14.1994 15.6574 14.5119 15.3449C14.8245 15.0323 15.0001 14.6084 15.0001 14.1663V11.6663M11.6667 5.83301C11.6667 6.49605 11.9301 7.13193 12.399 7.60077C12.8678 8.06962 13.5037 8.33301 14.1667 8.33301C14.8298 8.33301 15.4657 8.06962 15.9345 7.60077C16.4034 7.13193 16.6667 6.49605 16.6667 5.83301C16.6667 5.16997 16.4034 4.53408 15.9345 4.06524C15.4657 3.5964 14.8298 3.33301 14.1667 3.33301C13.5037 3.33301 12.8678 3.5964 12.399 4.06524C11.9301 4.53408 11.6667 5.16997 11.6667 5.83301Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9be259f6247ad4f441c2c71d559993e0.svg";
export { ForwardRef as ReactComponent };